module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb-eng.svg?14167f77f128b0f57a6263843017fc0f";